<template>
  <v-app id="create-account-app" class="createAccount">
    <div class="accountContainer">
      <progress-tracker
          :steps="steps">
      </progress-tracker>
      <img
        class="logo"
        :src="darkMode?brandingService.getLoginDarkLogoUrl():brandingService.getLoginLogoUrl()"
        alt="brandingService.getLoginLogoAlt()"
      />
      <section class="middle form" v-if="!submitted">
        <h1>Create An Account</h1>
        <v-form v-model="allFieldsValid" @submit.prevent>
          <v-text-field
            v-model="userName"
            class="name"
            :rules="[rules.required]"
            solo
            flat
            outlined
            dense
            label="Name"
          ></v-text-field>
          <v-text-field
            v-model="userEmail"
            :rules="[rules.required, rules.formatEmail]"
            class="email"
            solo
            flat
            outlined
            dense
            label="Business Email"
          ></v-text-field>
          <p class="subInstruction">Your email must be a business email address (personal emails not accepted).</p>
          
          <div class="termsOutline">
            <div class="left">
              <h4>Acknowlege Terms (required to use the service)</h4>
              <p class="documents">
                By continuing, you aknowledge that you have read and understand HP's 
                <a href="https://www.hp.com/us-en/privacy/privacy-central.html" target="_blank">Privacy Statement</a>,
                <a href="https://support.hp.com/us-en/document/ish_12775809-12775790-16" target="_blank">EULA</a>,
                and <a href="https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf" target="_blank">DPA</a>
              </p>
            </div>
            <div class="right">
              <label align="left" class="legend-title legend-switch action-switch">
                <input id="enabled" type="checkbox" v-model="termsAccepted" :aria-checked="termsAccepted.toString()">
                <span class="legend-slider"></span>
              </label>
            </div>
          </div>
          <div class="consent">
            <v-checkbox
              class="consentCheck"
              v-model="communicationConsent"
              label="I consent to receive communications from HP. I understand I may opt out of promotional and product information emails at any time."
            ></v-checkbox>
          </div>
          <button
            onsubmit="false"
            class="btn btn-primary submit"
            :disabled="!allFieldsValid || !termsAccepted"
            @click="submitEmail"
          >Submit</button>
        </v-form>
      </section>
      <section class="middle submitted" v-if="submitted">
        <div v-if="!error">
          <h1>Check Your Email</h1>
          <p class="message">Before you get started, we need to verify your email address. WXP Collaboration will send an email within 2-3 hours.</p>
          <img class="pli" src="dist/images/PLI-image.png">
        </div>
        <div v-if="error">
          <h1>Something Went Wrong</h1>
          <p class="message">
            {{ error }}
          </p>
        </div>
      </section>
      <p class="copywrite">© {{currentYear}} HP Inc. <a href="https://www.hp.com/us-en/privacy/privacy-central.html" target="_blank">Privacy Statement</a>,
        <a href="https://support.hp.com/us-en/document/ish_12775809-12775790-16" target="_blank">EULA</a>,
        and <a href="https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf" target="_blank">DPA</a>
      </p>
    </div>
  </v-app>
</template>

<script>
  import BrandingService from '../../../../services/branding.service';
  import ConfigService from '../../../../services/config.service';
  import ProgressTracker from '../../../../vueComponents/progressTracker/src/progressTracker.vue';
  import 'whatwg-fetch';
  import moment from "moment-timezone";

  let steps = [
    {
      name: 'create',
      display: 'Create',
      completion: 50,
      active: true
    },
    {
      name: 'verify',
      display: 'Verify',
      completion: 0,
      active: false
    },
    {
      name: 'info',
      display: 'My Info',
      completion: 0,
      active: false
    },
    {
      name: 'finished',
      display: 'Finished',
      completion: 0,
      active: false
    },
  ];

  export default {
    name: 'create-account',
    components: {
      'progress-tracker': ProgressTracker,
    },
    data: function() {
      const isDarkMode = document.documentElement.classList.contains('dark');
      return {
        allFieldsValid: false,
        brandingService: BrandingService,
        darkMode: isDarkMode,
        userEmail: '',
        userName: '',
        communicationConsent: false,
        steps: steps,
        submitted: false,
        termsAccepted: false,
        error: '',
        rules: {
          required: value => !!value || 'Required.',
          formatEmail: value => !value || this.validateEmailFormat(value)
        },
        currentYear: moment().year(),
      };
    },
    created: function() {
    },
    methods: {
      emailUpdated: function(newValue) {
        //validation
      },
      submitEmail: function() {
        let self = this;
        ConfigService.getInstance().getAdminService().then(function (serviceUrl) {
          window.fetch(serviceUrl + '/userreg/api/v1/user_requests', {
            method: 'POST',
            body: JSON.stringify({
              email: self.userEmail,
              name: self.userName,
              communicationConsent: self.communicationConsent,
            }),
            headers: {
              "Content-type": "application/json; charset=UTF-8"
            }
          }).then().then((response)  => {
            if (response.ok) {
              steps[0].completion = 100;
              steps[0].active = false;
              steps[1].completion = 50;
              steps[1].active = true;
              self.submitted = true;
            } else {
              self.submitted = true;
              self.error = 'An error occurred when trying to create your account. Please check the email entered and try again.';
            }
          })
        });
      },
      validateEmailFormat(value) {
        let regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return regexEmail.test(value) || 'Must be a valid email'
      },
    },
  }
</script>

<style lang="scss">
  .createAccount {
    .accountContainer {
      width: 50%;
      margin: auto;
      text-align: center;
      background-color: var(--panel-background);

      .progressTracker {
        margin-bottom: 62px;
        max-width: 465px;
      }
      .logo {
        height: 190px;
        margin: auto;
        padding-top: 50px;
        padding-bottom: 50px;
      }
      .middle {
        max-width: 465px;
        margin: auto;
        h1 {
          color: var(--text-color);
          text-align: center;
          font-size: 32px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          margin-bottom: 40px;
        }
        .email, .name {
          fieldset {
            height: 50px;
            border-radius: var(--text-input-border-radius);
            border-color: var(--stroke-decorative-default);
          }
          legend {
            display: none;
            border-radius: var(--border-radius);
            font-size: 16px;
          }
        }
        .subInstruction {
          text-align: left;
          color: var(--neutral2-color); // was #6D787E; 4.63:1 on white
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;
          padding-left: 15px;
        }
        .consent {
          margin-bottom: 29px;
          .v-label {
            margin-top: 15px;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
          }
        }
        .submit {
          height: 50px;
          width: 100%;
        }
        .contracts {
          font-size: 15px;
          font-weight: 400;
          line-height: 18px;
          a {
            color:  var(--tmp-default-color);
          }
        }
        .message {
          margin-bottom: 50px;
        }
        .pli {
          width: 100%;
        }
      }

      .termsOutline {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        border: 1px solid var(--stroke-decorative-default);
        padding: 15px;
        border-radius: var(--border-radius);

        .left {
        }
        .right {
        }
        .documents {
          font-size: 14px;
          font-weight: 400;
          color: var(--foreground-light);
        }
      } 
    }

    .v-input--selection-controls__input {
      color: var(--foreground-default);
    }
  }
</style>
